export enum SchedulerBlockDurationMinute {
    Five = 5,
    Ten = 10,
    Fifteen = 15,
    Thirty = 30,
    Sixty = 60,
    Ninety = 90
}